export const VoidCashInValue = {
  WrongAccountByUser: "Mistag: Wrong Account",
  WrongChannelByUser: "Mistag: Wrong Channel",
  Others: "Others",
};

export default VoidCashInValue;
